// Port of src/app/services/youtube/youtube-tokens.service.ts.
// localStorage key names are IDENTICAL to the Angular app so already-connected
// users stay connected after the React migration.

import { environment } from '../../config/environment';
import { useUserStore } from '../../stores/user-store';

export const accessTokenAddress = 'youtubeAccessToken';
export const refreshTokenAddress = 'youtubeRefreshToken';
export const isYoutubeConnectedAddress = 'isYoutubeConnected';
export const connectedUserEmailAddress = 'youtubeUserEmailAddress';

export function clearCredentials(): void {
  localStorage.removeItem(accessTokenAddress);
  localStorage.removeItem(refreshTokenAddress);
  localStorage.removeItem(isYoutubeConnectedAddress);
  localStorage.removeItem(connectedUserEmailAddress);

  const userStore = useUserStore.getState();
  const user = userStore.user;
  if (user) {
    user.isYoutubeConnected = false;
    userStore.setUser(user);
  }
}

export function setRefreshToken(refreshToken: string): void {
  if (localStorage.getItem(isYoutubeConnectedAddress)) {
    localStorage.setItem(refreshTokenAddress, refreshToken);
  } else {
    environment.youtubeDefaultUserRefreshToken = refreshToken;
  }
}

export function setAccessToken(accessToken: string): void {
  if (localStorage.getItem(isYoutubeConnectedAddress)) {
    localStorage.setItem(accessTokenAddress, accessToken);
  } else {
    environment.youtubeDefaultUserAccessToken = accessToken;
  }
}

export function setIsYoutubeConnected(): void {
  localStorage.setItem(isYoutubeConnectedAddress, 'true');
}

export function setTokens(accessToken: string, refreshToken: string, email: string): void {
  localStorage.setItem(accessTokenAddress, accessToken);
  localStorage.setItem(refreshTokenAddress, refreshToken);
  localStorage.setItem(connectedUserEmailAddress, email);
}

export function getAccessToken(): string {
  if (getIsYoutubeConnected() && useUserStore.getState().user?.isSubscribed) {
    return localStorage.getItem(accessTokenAddress)!;
  } else {
    return environment.youtubeDefaultUserAccessToken;
  }
}

export function getConnectedUserEmailAddress(): string {
  return localStorage.getItem(connectedUserEmailAddress)!;
}

export function getRefreshToken(): string {
  if (getIsYoutubeConnected() && useUserStore.getState().user?.isSubscribed) {
    return localStorage.getItem(refreshTokenAddress)!;
  } else {
    return environment.youtubeDefaultUserRefreshToken;
  }
}

export function getIsYoutubeConnected(): boolean {
  const value = localStorage.getItem(isYoutubeConnectedAddress);
  return value === 'true';
}
